import {
  PUBLIC_PATIENT_TREATMENT_PLAN_LIST_REQUEST,
  PUBLIC_PATIENT_TREATMENT_PLAN_LIST_SUCCESS,
  PUBLIC_PATIENT_TREATMENT_PLAN_LIST_FAIL,
  PUBLIC_PATIENT_TREATMENT_PLAN_LIST_RESET,
  PUBLIC_PATIENT_TREATMENT_PLAN_DETAILS_REQUEST,
  PUBLIC_PATIENT_TREATMENT_PLAN_DETAILS_SUCCESS,
  PUBLIC_PATIENT_TREATMENT_PLAN_DETAILS_FAIL,
  PUBLIC_PATIENT_TREATMENT_PLAN_DETAILS_RESET,
  PUBLIC_TENANT_DETAILS_REQUEST,
  PUBLIC_TENANT_DETAILS_SUCCESS,
  PUBLIC_TENANT_DETAILS_FAIL,
  PUBLIC_TENANT_DETAILS_RESET,
  PUBLIC_PATIENT_APPROVE_TREATMENT_PLAN_REQUEST,
  PUBLIC_PATIENT_APPROVE_TREATMENT_PLAN_SUCCESS,
  PUBLIC_PATIENT_APPROVE_TREATMENT_PLAN_FAIL,
  PUBLIC_PATIENT_APPROVE_TREATMENT_PLAN_RESET,
  PUBLIC_PATIENT_CANCEL_TREATMENT_PLAN_REQUEST,
  PUBLIC_PATIENT_CANCEL_TREATMENT_PLAN_SUCCESS,
  PUBLIC_PATIENT_CANCEL_TREATMENT_PLAN_FAIL,
  PUBLIC_PATIENT_CANCEL_TREATMENT_PLAN_RESET,
  PUBLIC_PATIENT_DOWNLOADPDF_TREATMENT_PLAN_REQUEST,
  PUBLIC_PATIENT_DOWNLOADPDF_TREATMENT_PLAN_SUCCESS,
  PUBLIC_PATIENT_DOWNLOADPDF_TREATMENT_PLAN_FAIL,
  PUBLIC_PATIENT_DOWNLOADPDF_TREATMENT_PLAN_RESET,
  PUBLIC_COURSES_LIST_REQUEST,
  PUBLIC_COURSES_LIST_SUCCESS,
  PUBLIC_COURSES_LIST_FAIL,
  PUBLIC_COURSES_LIST_RESET,
  PUBLIC_ATTENDEE_COURSE_REGISTER_REQUEST,
  PUBLIC_ATTENDEE_COURSE_REGISTER_SUCCESS,
  PUBLIC_ATTENDEE_COURSE_REGISTER_FAIL,
  PUBLIC_ATTENDEE_COURSE_REGISTER_RESET,
  PUBLIC_INVITE_INFO_REQUEST,
  PUBLIC_INVITE_INFO_SUCCESS,
  PUBLIC_INVITE_INFO_FAIL,
  PUBLIC_INVITE_INFO_RESET,
  PUBLIC_ACCEPT_INVITE_REQUEST,
  PUBLIC_ACCEPT_INVITE_SUCCESS,
  PUBLIC_ACCEPT_INVITE_FAIL,
  PUBLIC_ACCEPT_INVITE_RESET,
  PUBLIC_PORTAL_PATIENT_DETAILS_REQUEST,
  PUBLIC_PORTAL_PATIENT_DETAILS_SUCCESS,
  PUBLIC_PORTAL_PATIENT_DETAILS_FAIL,
  PUBLIC_PORTAL_PATIENT_DETAILS_RESET,
  PUBLIC_PORTAL_PATIENT_VERIFY_PIN_REQUEST,
  PUBLIC_PORTAL_PATIENT_VERIFY_PIN_SUCCESS,
  PUBLIC_PORTAL_PATIENT_VERIFY_PIN_FAIL,
  PUBLIC_PORTAL_PATIENT_VERIFY_PIN_RESET,
  PUBLIC_PORTAL_GET_TREATMENT_PLANS_REQUEST,
  PUBLIC_PORTAL_GET_TREATMENT_PLANS_SUCCESS,
  PUBLIC_PORTAL_GET_TREATMENT_PLANS_FAIL,
  PUBLIC_PORTAL_GET_TREATMENT_PLANS_RESET,
  PUBLIC_PORTAL_TREATMENT_PLAN_APPROVE_REQUEST,
  PUBLIC_PORTAL_TREATMENT_PLAN_APPROVE_SUCCESS,
  PUBLIC_PORTAL_TREATMENT_PLAN_APPROVE_FAIL,
  PUBLIC_PORTAL_TREATMENT_PLAN_APPROVE_RESET,
  PUBLIC_PORTAL_TREATMENT_PLAN_CANCEL_REQUEST,
  PUBLIC_PORTAL_TREATMENT_PLAN_CANCEL_SUCCESS,
  PUBLIC_PORTAL_TREATMENT_PLAN_CANCEL_FAIL,
  PUBLIC_PORTAL_TREATMENT_PLAN_CANCEL_RESET,
  PUBLIC_PORTAL_TREATMENT_PLAN_DOWNLOADPDF_REQUEST,
  PUBLIC_PORTAL_TREATMENT_PLAN_DOWNLOADPDF_SUCCESS,
  PUBLIC_PORTAL_TREATMENT_PLAN_DOWNLOADPDF_FAIL,
  PUBLIC_PORTAL_TREATMENT_PLAN_DOWNLOADPDF_RESET,
  PUBLIC_CHECK_USER_INVITE_REQUEST,
  PUBLIC_CHECK_USER_INVITE_SUCCESS,
  PUBLIC_CHECK_USER_INVITE_FAIL,
  PUBLIC_CHECK_USER_INVITE_RESET,
} from "../constants/publicConstants";

export const publicPatientTreatmentPlanListReducer = (
  state = { patientInfo: {} },
  action
) => {
  switch (action.type) {
    case PUBLIC_PATIENT_TREATMENT_PLAN_LIST_REQUEST:
      return { loading: true, patientInfo: {} };
    case PUBLIC_PATIENT_TREATMENT_PLAN_LIST_SUCCESS:
      return {
        loading: false,
        patientInfo: action.payload, // Store the entire payload as patientInfo
        pages: action.payload.pages,
        page: action.payload.page,
      };
    case PUBLIC_PATIENT_TREATMENT_PLAN_LIST_FAIL:
      return { loading: false, error: action.payload };
    case PUBLIC_PATIENT_TREATMENT_PLAN_LIST_RESET:
      return { patientInfo: {} };
    default:
      return state;
  }
};

export const publicPatientTreatmentPlanDetailsReducer = (
  state = { treatmentPlan: {} },
  action
) => {
  switch (action.type) {
    case PUBLIC_PATIENT_TREATMENT_PLAN_DETAILS_REQUEST:
      return { loading: true, ...state };
    case PUBLIC_PATIENT_TREATMENT_PLAN_DETAILS_SUCCESS:
      return { loading: false, treatmentPlan: action.payload };
    case PUBLIC_PATIENT_TREATMENT_PLAN_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    case PUBLIC_PATIENT_TREATMENT_PLAN_DETAILS_RESET:
      return { treatmentPlan: {} };
    default:
      return state;
  }
};

export const publicTenantDetailsReducer = (state = { tenant: {} }, action) => {
  switch (action.type) {
    case PUBLIC_TENANT_DETAILS_REQUEST:
      return { loading: true, tenant: {} };
    case PUBLIC_TENANT_DETAILS_SUCCESS:
      return { loading: false, tenant: action.payload };
    case PUBLIC_TENANT_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    case PUBLIC_TENANT_DETAILS_RESET:
      return { tenant: {} };
    default:
      return state;
  }
};

export const publicPatientApproveTreatmentPlanReducer = (
  state = { success: false },
  action
) => {
  switch (action.type) {
    case PUBLIC_PATIENT_APPROVE_TREATMENT_PLAN_REQUEST:
      return { loading: true };
    case PUBLIC_PATIENT_APPROVE_TREATMENT_PLAN_SUCCESS:
      return { loading: false, success: true };
    case PUBLIC_PATIENT_APPROVE_TREATMENT_PLAN_FAIL:
      return { loading: false, error: action.payload };
    case PUBLIC_PATIENT_APPROVE_TREATMENT_PLAN_RESET:
      return { success: false };
    default:
      return state;
  }
};

export const publicPatientCancelTreatmentPlanReducer = (
  state = { success: false },
  action
) => {
  switch (action.type) {
    case PUBLIC_PATIENT_CANCEL_TREATMENT_PLAN_REQUEST:
      return { loading: true };
    case PUBLIC_PATIENT_CANCEL_TREATMENT_PLAN_SUCCESS:
      return { loading: false, success: true };
    case PUBLIC_PATIENT_CANCEL_TREATMENT_PLAN_FAIL:
      return { loading: false, error: action.payload };
    case PUBLIC_PATIENT_CANCEL_TREATMENT_PLAN_RESET:
      return { success: false };
    default:
      return state;
  }
};

export const publicPatientDownloadPdfTreatmentPlanReducer = (
  state = {},
  action
) => {
  switch (action.type) {
    case PUBLIC_PATIENT_DOWNLOADPDF_TREATMENT_PLAN_REQUEST:
      return { loading: true };
    case PUBLIC_PATIENT_DOWNLOADPDF_TREATMENT_PLAN_SUCCESS:
      return { loading: false, pdf: action.payload };
    case PUBLIC_PATIENT_DOWNLOADPDF_TREATMENT_PLAN_FAIL:
      return { loading: false, error: action.payload };
    case PUBLIC_PATIENT_DOWNLOADPDF_TREATMENT_PLAN_RESET:
      return {};
    default:
      return state;
  }
};

export const publicCoursesListReducer = (state = { courses: [] }, action) => {
  switch (action.type) {
    case PUBLIC_COURSES_LIST_REQUEST:
      return { loading: true, courses: [] };
    case PUBLIC_COURSES_LIST_SUCCESS:
      return { loading: false, courses: action.payload };
    case PUBLIC_COURSES_LIST_FAIL:
      return { loading: false, error: action.payload };
    case PUBLIC_COURSES_LIST_RESET:
      return { courses: [] };
    default:
      return state;
  }
};

export const publicAttendeeCourseRegisterReducer = (state = {}, action) => {
  switch (action.type) {
    case PUBLIC_ATTENDEE_COURSE_REGISTER_REQUEST:
      return { loading: true };
    case PUBLIC_ATTENDEE_COURSE_REGISTER_SUCCESS:
      return { loading: false, success: true };
    case PUBLIC_ATTENDEE_COURSE_REGISTER_FAIL:
      return { loading: false, error: action.payload };
    case PUBLIC_ATTENDEE_COURSE_REGISTER_RESET:
      return {};
    default:
      return state;
  }
};

export const publicInviteInfoReducer = (state = { info: {} }, action) => {
  switch (action.type) {
    case PUBLIC_INVITE_INFO_REQUEST:
      return { loading: true, info: {} };
    case PUBLIC_INVITE_INFO_SUCCESS:
      return { loading: false, info: action.payload };
    case PUBLIC_INVITE_INFO_FAIL:
      return { loading: false, error: action.payload };
    case PUBLIC_INVITE_INFO_RESET:
      return { info: {} };
    default:
      return state;
  }
};

export const publicAcceptInviteReducer = (state = {}, action) => {
  switch (action.type) {
    case PUBLIC_ACCEPT_INVITE_REQUEST:
      return { loading: true };
    case PUBLIC_ACCEPT_INVITE_SUCCESS:
      return { loading: false, success: true, data: action.payload };
    case PUBLIC_ACCEPT_INVITE_FAIL:
      return { loading: false, error: action.payload };
    case PUBLIC_ACCEPT_INVITE_RESET:
      return {};
    default:
      return state;
  }
};

export const publicPortalPatientDetailsReducer = (
  state = { patientPortalPublicDetails: {} },
  action
) => {
  switch (action.type) {
    case PUBLIC_PORTAL_PATIENT_DETAILS_REQUEST:
      return { loading: true, patientPortalPublicDetails: {} };
    case PUBLIC_PORTAL_PATIENT_DETAILS_SUCCESS:
      return { loading: false, patientPortalPublicDetails: action.payload };
    case PUBLIC_PORTAL_PATIENT_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    case PUBLIC_PORTAL_PATIENT_DETAILS_RESET:
      return { patientPortalPublicDetails: {} };
    default:
      return state;
  }
};

export const publicPortalPatientVerifyPinReducer = (
  state = { patientToken: {} },
  action
) => {
  switch (action.type) {
    case PUBLIC_PORTAL_PATIENT_VERIFY_PIN_REQUEST:
      return { loading: true, patientToken: {} };
    case PUBLIC_PORTAL_PATIENT_VERIFY_PIN_SUCCESS:
      return { loading: false, patientToken: action.payload };
    case PUBLIC_PORTAL_PATIENT_VERIFY_PIN_FAIL:
      return { loading: false, error: action.payload };
    case PUBLIC_PORTAL_PATIENT_VERIFY_PIN_RESET:
      return { patientToken: {} };
    default:
      return state;
  }
};

export const publicPortalGetTreatmentPlansReducer = (
  state = { treatmentPlans: [] },
  action
) => {
  switch (action.type) {
    case PUBLIC_PORTAL_GET_TREATMENT_PLANS_REQUEST:
      return { loading: true, treatmentPlans: [] };
    case PUBLIC_PORTAL_GET_TREATMENT_PLANS_SUCCESS:
      return { loading: false, treatmentPlans: action.payload };
    case PUBLIC_PORTAL_GET_TREATMENT_PLANS_FAIL:
      return { loading: false, error: action.payload };
    case PUBLIC_PORTAL_GET_TREATMENT_PLANS_RESET:
      return { treatmentPlans: [] };
    default:
      return state;
  }
};

export const publicPortalTreatmentPlanApproveReducer = (
  state = { success: false },
  action
) => {
  switch (action.type) {
    case PUBLIC_PORTAL_TREATMENT_PLAN_APPROVE_REQUEST:
      return { loading: true };
    case PUBLIC_PORTAL_TREATMENT_PLAN_APPROVE_SUCCESS:
      return { loading: false, success: true };
    case PUBLIC_PORTAL_TREATMENT_PLAN_APPROVE_FAIL:
      return { loading: false, error: action.payload };
    case PUBLIC_PORTAL_TREATMENT_PLAN_APPROVE_RESET:
      return { success: false };
    default:
      return state;
  }
};

export const publicPortalTreatmentPlanCancelReducer = (
  state = { success: false },
  action
) => {
  switch (action.type) {
    case PUBLIC_PORTAL_TREATMENT_PLAN_CANCEL_REQUEST:
      return { loading: true };
    case PUBLIC_PORTAL_TREATMENT_PLAN_CANCEL_SUCCESS:
      return { loading: false, success: true };
    case PUBLIC_PORTAL_TREATMENT_PLAN_CANCEL_FAIL:
      return { loading: false, error: action.payload };
    case PUBLIC_PORTAL_TREATMENT_PLAN_CANCEL_RESET:
      return { success: false };
    default:
      return state;
  }
};

export const publicPortalTreatmentPlanDownloadPdfReducer = (
  state = {},
  action
) => {
  switch (action.type) {
    case PUBLIC_PORTAL_TREATMENT_PLAN_DOWNLOADPDF_REQUEST:
      return { loading: true };
    case PUBLIC_PORTAL_TREATMENT_PLAN_DOWNLOADPDF_SUCCESS:
      return { loading: false, success: true, pdf: action.payload };
    case PUBLIC_PORTAL_TREATMENT_PLAN_DOWNLOADPDF_FAIL:
      return { loading: false, error: action.payload };
    case PUBLIC_PORTAL_TREATMENT_PLAN_DOWNLOADPDF_RESET:
      return { success: false };
    default:
      return state;
  }
};

export const publicCheckUserInviteReducer = (state = {}, action) => {
  switch (action.type) {
    case PUBLIC_CHECK_USER_INVITE_REQUEST:
      return { loading: true };
    case PUBLIC_CHECK_USER_INVITE_SUCCESS:
      return { loading: false, success: true, check: action.payload };
    case PUBLIC_CHECK_USER_INVITE_FAIL:
      return { loading: false, error: action.payload };
    case PUBLIC_CHECK_USER_INVITE_RESET:
      return {};
    default:
      return state;
  }
};
